import React, { Component } from 'react';
import { connect } from 'react-redux';
import styles from './styles.scss';
import { userActions } from 'actions/api/users';
import MaterialSelect from 'components/util/materialSelect';
import { capitalize } from 'lodash';
import LodIcon from 'components/util/lodIcon';
import { openConfirmModal } from 'actions/modals';

class UserRow extends Component {
  typeOptions = () => {
    const { userTypes } = this.props;
    let options = [];
    for (let k in userTypes) {
      options.push({
        label: capitalize(userTypes[parseInt(k, 10)]),
        value: parseInt(k, 10)
      });
    }
    return options;
  };

  activatedOptions = () => {
    return [{ value: false, label: 'No' }, { value: true, label: 'Yes' }];
  };

  handleChange = (field, value) => {
    this.props.dispatch(
      userActions.save({
        data: {
          id: this.props.user.id,
          [field]: value
        }
      })
    );
  };

  deleteUser = () => {
    this.props.dispatch(
      openConfirmModal({
        text: `Are you sure you want to remove ${
          this.props.user.name
        } from the app?`,
        onConfirm: () => {
          this.props.dispatch(userActions.delete({ id: this.props.user.id }));
        }
      })
    );
  };

  render() {
    const { user } = this.props;

    return (
      <tr>
        <td>
          {user.name}{' '}
          {user.user_type_enum === 1 ? (
            <span>(N/A)</span>
          ) : (
            <span>
              ({user.number_verified}/{user.total_strings})
            </span>
          )}
        </td>
        <td>{user.email}</td>
        <td>
          <MaterialSelect
            options={this.typeOptions()}
            value={user.user_type_enum}
            onChange={val => this.handleChange('user_type', val)}
          />
        </td>
        <td>
          {user.user_type_enum === 2 ? (
            <MaterialSelect
              options={this.props.languageOptions}
              value={user.language_id}
              onChange={val => this.handleChange('language_id', val)}
              hintText="Language"
              autoWidth
            />
          ) : (
            'N/A'
          )}
        </td>
        <td>
          <MaterialSelect
            options={this.activatedOptions()}
            value={user.is_activated}
            disabled={!user.language_id && user.user_type_enum === 2}
            onChange={val => this.handleChange('is_activated', val)}
          />
        </td>
        <td className={styles.tightCol}>
          {user.id !== this.props.currentUser.id && (
            <LodIcon
              icon="x"
              className={styles.deleteIcon}
              onClick={this.deleteUser}
            />
          )}
        </td>
      </tr>
    );
  }
}

export default connect(state => {
  return {
    userTypes: state.config.user_types,
    currentUser: state.users.map[state.sessionSettings.currentUserId]
  };
})(UserRow);



// WEBPACK FOOTER //
// ./src/components/dashboard/developerDashboard/manageUsers/userRow/index.js